@if(hideButton) {
<div class="all" [ngClass]="{'collapsed': !collapseValue}" (click)="sendCollapse()"
  [matTooltip]="!collapseValue? menuBottom?.title: null" matTooltipClass="induxtry-tooltip">
  @if(collapseValue) {
  <mat-icon class="left" [svgIcon]="menuBottom?.icon[0]"></mat-icon>
  <span class="close-menu">{{menuBottom?.title}}</span>
  } @else {
  <mat-icon class="left" [ngClass]="{'collapsed': !collapseValue}" style="margin: auto; left: 0;"
    [svgIcon]="menuBottom?.icon[1]"></mat-icon>
  }
</div>
}
